import React, { useEffect, useState } from 'react';
import Lenis from 'lenis';
import Hero from './Hero';
import Marquee from './Marquee';
import Manifesto from './Manifesto';
import RestaurantSection from './RestaurantSection';
import Footer from './Footer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Landing = () => {
  const [total, setTotal] = useState(0);
  const [refCode] = useState(
    () => new URLSearchParams(window.location.search).get('ref')
  );

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        const el = document.querySelector(a.getAttribute('href'));
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -20 });
        }
      }
    };
    document.addEventListener('click', onAnchor);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener('click', onAnchor);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    fetch(`${API}/waitlist/stats`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && setTotal(d.total))
      .catch(() => {});
  }, []);

  return (
    <>
      <Hero refCode={refCode} total={total} onJoined={(data) => setTotal(data.total)} />
      <Marquee />
      <Manifesto />
      <RestaurantSection />
      <Footer />
    </>
  );
};

export default Landing;
